export default __webpack_public_path__ + "static/media/net-win.68712f1f.webp";